import { queryOptions } from '@tanstack/react-query'

import { LegacyParams } from '@/types/supports'

import { fetchParticipatedAds } from './methods'

const participatedAdQueryKeys = {
  all: ['participatedAds'] as const,
  list: (params: LegacyParams) => [...participatedAdQueryKeys.all, 'list', params] as const
}

export const participatedAdQueryOptions = {
  list: (params: LegacyParams) =>
    queryOptions({
      queryKey: participatedAdQueryKeys.list(params),
      queryFn: () => fetchParticipatedAds(params)
    })
}
